module.exports = __webpack_public_path__ + "img/pinterest-social-logo-svgrepo-com-dark.143f0343.svg";